import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
// import { fetchTree } from '@/api/PMS/treeList/index.js'
import { houseTreeList } from '@/api/PMS/baseInformation/meterManager';
export default {
  props: {
    showDialog: Boolean,
    areaId: {
      type: String || Number,
      default: ''
    }
  },
  data: function data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'pmsTree',
        label: 'name'
      },
      treeData: [],
      detialList: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.loadMenuTree();
      }
    },
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    this.loadMenuTree();
  },
  methods: {
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      console.log(data);
      return data.name.indexOf(value) !== -1;
    },
    loadMenuTree: function loadMenuTree() {
      var _this = this;

      // 加载树
      houseTreeList({
        flag: '0'
      }).then(function (response) {
        _this.checkedId = 0;
        _this.treeData = response.data.data;

        _this.treeFormat(_this.treeData);
      });
    },
    treeFormat: function treeFormat(list) {
      var _this2 = this;

      list.forEach(function (item) {
        _this2.treeChildFormat(item);

        if (item.pmsTree && item.pmsTree.length > 0) {
          _this2.treeFormat(item.pmsTree);
        }
      });
    },
    treeChildFormat: function treeChildFormat(child) {
      child.checkedId = ++this.checkedId;
    },
    checkChange: function checkChange() {
      var checkedTreeNodes = this.$refs.tree.getCheckedNodes();
      var filterData = checkedTreeNodes.filter(function (item) {
        return item.flag === '211';
      });
      this.detialList = filterData;
      this.detialList = filterData.map(function (item) {
        return {
          resourceId: item.id,
          flag: item.flag
        };
      });
    },
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      if (data.flag === '0') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanliquyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '1') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fenzu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '2') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'louyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '21') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'danyuan'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '211') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fangjian'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '212') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanggaowei'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '3') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'cheku'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '31') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'chewei'
          }
        }), h("span", [node.label])]);
      }
    },
    handCreate: function handCreate() {
      if (this.detialList && this.detialList.length > 0) {
        this.$emit('handCancle', true);
        this.$emit('sendHouseData', this.detialList);
      } else {
        this.$message.error('请选择');
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};